var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navs-box"},[_c('div',{staticClass:"navs"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"item",on:{"click":function($event){return _vm.gopage(item.url)}}},[_c('img',{staticClass:"item-img",attrs:{"src":item.image}}),_c('div',{staticClass:"item-title"},[_vm._v(_vm._s(item.text))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }